<template>
  <el-form :inline="true" :model="formApartment">
    <!-- 新增租客 -->
    <el-dialog
        :title="$t('apartmentRoomList.addTenant')"
        :modal-append-to-body="false"
        :lock-scroll="false"
        :visible.sync="addTenantVisible"
        width="400px"
      >
        <el-form :inline="true" :model="formAddTenant" ref="formAddTenant" class="demo-ruleForm">
          <el-form-item :label="$t('apartmentRoomList.tenantName')" label-width="120px" prop="tenantName" :rules="[{ required: true, message: '租客名称不能为空'}]">
            <el-input
              type="text"
              v-model="formAddTenant.tenantName"
              :placeholder="$t('apartmentRoomList.tenantName')"
              maxlength="12"
              show-word-limit
              style="width:200px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$t('apartmentRoomList.IDCard')"
            label-width="120px"
            prop="tenantIdentityId"
          >
            <el-input
              v-model.number="formAddTenant.tenantIdentityId"
              :placeholder="$t('apartmentRoomList.IDCard')"
              maxlength="18"
              show-word-limit
              style="width:200px"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="$t('apartmentRoomList.mobile')"
            label-width="120px"
            prop="mobile"
          >
            <el-input
              v-model.number="formAddTenant.mobile"
              :placeholder="$t('apartmentRoomList.mobile')"
              maxlength="12"
              show-word-limit
              style="width:200px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('apartmentRoomList.email')"
            label-width="120px"
            prop="email"
            :rules="[
             { type: 'email', message: $t('apartmentRoomList.email-input'), trigger: ['blur', 'change'] }
            ]"
          >
            <el-input
              v-model="formAddTenant.email"
              :placeholder="$t('apartmentRoomList.email')"
              maxlength="18"
              style="width:200px"
            ></el-input>
          </el-form-item>
          <el-form-item style="display:flex;justify-content:center;align-items:center;">
            <el-button type="primary" @click="confirmAddTenant">{{$t('apartmentRoomList.confirm')}}</el-button>
            <el-button type="primary" @click="closeAddTenant">{{$t('apartmentRoomList.cancel')}}</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 租客信息 -->
    <el-dialog
      :title="$t('apartmentRoomList.tenatInfo')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="tenantInfoVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="formTenantInfo"
        ref="formTenantInfo"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomList.tenantName')"
          label-width="120px"
          prop="tenantName"
          :rules="[{ required: true, message:$t('apartmentRoomList.tenantName')}]"
        >
          <el-input
            type="text"
            v-model="formTenantInfo.tenantName"
            :placeholder="$t('apartmentRoomList.tenantName')"
            maxlength="12"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomList.IDCard')"
          label-width="120px"
          prop="tenantIdentityId"
        >
          <el-input
            type="text"
            v-model="formTenantInfo.tenantIdentityId"
            :placeholder="$t('apartmentRoomList.IDCard')"
            maxlength="18"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomList.mobile')"
          label-width="120px"
          prop="mobile"
        >
          <el-input
            type="text"
            v-model.number="formTenantInfo.mobile"
            :placeholder="$t('apartmentRoomList.mobile')"
            maxlength="12"
            show-word-limit
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomList.email')"
          label-width="120px"
          prop="email"
          :rules="[
            {
              type: 'email',
              message: $t('apartmentRoomList.email-input'),
              trigger: ['blur', 'change']
            }
          ]"
        >
          <el-input
            v-model="formTenantInfo.email"
            :placeholder="$t('apartmentRoomList.email')"
            maxlength="18"
            style="width:200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display:flex;justify-content:center;align-items:center;"
        >
          <el-button type="danger" @click="checkOut">{{$t('apartmentRoomList.checkOut')}}</el-button>
          <el-button type="primary" @click="confirmTenantInfo">{{$t('apartmentRoomList.save')}}</el-button>
          <el-button type="primary" @click="tenantInfoVisible = false"
            >{{$t('apartmentRoomList.cancel')}}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 选择租客 -->
    <el-dialog
      :title="$t('apartmentRoomList.chooseTenant')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="tenantListVisible"
      width="600px"
      style="margin-top:-50px"
    >
      <el-form-item :label="$t('apartmentRoomList.tenantName')" style="margin-top:-15px">
         <el-input v-model="selectForm.tenantName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item style="margin-top:-15px">
        <el-button type="primary" @click="onSelectTenant">{{$t('apartmentRoomList.qurey')}}</el-button>
      </el-form-item>
      <el-table
        ref="singleTable"
        :data="tenantList"
        highlight-current-row
        @current-change="handleCurrentChange"
        height=280px
        style="margin-top:-10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="tenantName"
          :label="$t('apartmentRoomList.tenantName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantPhone"
          label="租客电话"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantEmail"
          label="租客邮箱"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChangeT"
          @handleCurrentChangeSub="handleCurrentChangeT"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseTenant">{{$t('apartmentRoomList.confirmChoose')}}</el-button>
        <el-button type="primary" @click="tenantListVisible = false;checkInVisible = true;">{{$t('apartmentRoomList.cancel')}}</el-button>
      </div>
    </el-dialog>
    <!-- 租客入住 -->
    <el-dialog
      :title="$t('apartmentRoomList.tenantCheckIn')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="checkInVisible"
      width="600px"
      style="margin-top:-50px"
    >
      <el-form
        :inline="true"
        :model="formTenant"
        ref="formTenant"
        class="demo-ruleForm"
        style="margin-top:-20px"
      >
        <el-form-item
          :label="$t('apartmentRoomList.tenant')"
          label-width="160px"
          prop="tenantName"
          :rules="[{ required: true, message:$t('apartmentRoomList.chooseTenant')}]"
        >
          <el-col :span="14">
            <el-input
              v-model="formTenant.tenantName"
              :placeholder="$t('apartmentRoomList.chooseTenant')"
            ></el-input>
          </el-col>
          <el-col :span="10" style="display:flex;justify-content:center;align-items:center;">
            <el-button-group style="width:120px">
            <el-button size="medium" :title="$t('apartmentRoomList.chooseTenant')" icon="el-icon-search" type="primary" @click="chooseTenant"></el-button>
            <el-button size="medium" :title="$t('apartmentRoomList.addTenant')" icon="el-icon-plus" type="primary" @click="addTenant"></el-button>
            </el-button-group>
          </el-col>
        </el-form-item>

        <el-form-item :label="$t('apartmentRoomList.roomInfo')" label-width="160px" prop="mobile">
         <el-col :span="12">
          <el-input
            v-model="currCheckInRoomData.roomName"
            :placeholder="$t('apartmentRoomList.roomName-Input')"
            maxlength="18"
            disabled
            style="width:170px"
          ></el-input>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="formTenant.manage" size="mini" style="width:200px">
              <el-tooltip :content="$t('apartmentRoomList.tenantOnlyOpenDoor')" placement="top" effect="light">
                <el-radio label="0">{{$t('apartmentRoomList.tenant')}}</el-radio>
              </el-tooltip>
              <el-tooltip :content="$t('apartmentRoomList.adminLockManage')" placement="top" effect="light">
                <el-radio label="1">{{$t('apartmentRoomList.admin')}}</el-radio>
              </el-tooltip>
            </el-radio-group>
          </el-col>
        </el-form-item>
        
        <el-form-item :label="$t('apartmentRoomList.isSendMessage')" label-width="160px" prop="mobile">
          <el-radio v-model="formTenant.sendMessageChecked" label
            >{{$t('apartmentRoomList.nosend')}}</el-radio
          >
          <el-radio v-model="formTenant.sendMessageChecked" label="0"
            >{{$t('apartmentRoomList.SMS')}}</el-radio
          >
          <el-radio v-model="formTenant.sendMessageChecked" label="1"
            >{{$t('apartmentRoomList.sendEmail')}}</el-radio
          >
        </el-form-item>
        <!-- <el-form-item label="授权内容" label-width="100px" prop="mobile">
          <el-col :span="18" style="width:300px">
            <el-radio v-model="formTenant.validType" label="0">密码</el-radio>
            <el-radio v-show="this.formTenant.deviceType==1" v-model="formTenant.validType" label="1">卡片</el-radio>
            <el-radio v-show="this.formTenant.deviceType==4" v-model="formTenant.validType" label="2">蓝牙钥匙</el-radio>
          </el-col>
          <el-col :span="6">
            <el-input
              v-show="formTenant.validType == '1'"
              v-model="formTenant.card"
              placeholder="请输入卡号"
              style="width:130px"
            ></el-input>
          </el-col>
        </el-form-item> -->
        <el-form-item
          :label="$t('apartmentRoomList.beginDate')"
          label-width="160px"
          prop="date1"
          :rules="[{ required: true, message: $t('apartmentRoomList.beginDate-input') }]"
        >
          <el-date-picker
            type="date"
            :placeholder="$t('apartmentRoomList.chooseDate')"
            v-model="formTenant.date1"
            style="width:200px"
          ></el-date-picker>
          -
          <!-- <el-time-picker
            placeholder="选择时间"
            v-model="formTenant.time1"
            style="width:150px"
          ></el-time-picker> -->
          <el-time-select
            v-model="formTenant.time1"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:30'
            }"
            style="width:150px"
            placeholder="$t('apartmentRoomList.chooseTime')">
          </el-time-select>
        </el-form-item>

        <el-form-item
          :label="$t('apartmentRoomList.endDate')"
          label-width="160px"
          prop="date2"
          :rules="[{ required: true, message: $t('apartmentRoomList.endDate')}]"
        >
          <el-date-picker
            type="date"
            :placeholder="$t('apartmentRoomList.chooseDate')"
            v-model="formTenant.date2"
            style="width:200px"
          ></el-date-picker>
          -
          <el-time-select
            v-model="formTenant.time2"
            :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:30'
            }"
            style="width:150px"
            placeholder="$t('apartmentRoomList.chooseTime')">
          </el-time-select>
          <!-- <el-time-picker
            placeholder="选择时间"
            v-model="formTenant.time2"
            style="width:150px"
          ></el-time-picker> -->
        </el-form-item>
        <el-form-item
          style="display:flex;justify-content:center;align-items:center;"
        >
          <el-button type="primary" @click="confirmCheckIn">{{$t('apartmentRoomList.confirm')}}</el-button>
          <el-button type="primary" @click="checkInVisible = false"
            >{{$t('apartmentRoomList.cancel')}}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-card class="box-card clearfloat" style="margin-top:5px;">
      <div
        v-for="b in this.$store.state.apartmentBuilds"
        :key="b.buildingId"
        class="text item"
      >
        <el-container>
          <el-main style="text-align: center;">
            <div v-for="f in b.floorList" :key="f.floorId" class="text item">
              <el-container>
                <el-aside style="margin-top:2px;width:100px;border:solid 1px #E4E7ED;cursor:pointer">
                  <div :title="formApartment.apartmentType =='0'?$t('apartmentRoomList.publicArea'):f.floorName+$t('apartmentRoomList.publicArea')" @click="commomArea(f)" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;background-color: #F2F6FC;">
                    {{formApartment.apartmentType == "0"? $t('apartmentRoomList.publicArea'): f.floorName +"\n"+$t('apartmentRoomList.publicArea')}}
                  </div>
                </el-aside>

                <el-main>
                  <div v-for="r in f.roomList" :key="r.roomId" class="text item">
                    <el-col :span="8" style="padding:1px;min-width:250px">
                      <el-card class="box-card" shadow="hover">
                        <div slot="header">
                          <el-col :span="16">
                            <el-col :span="6" style="margin-top:-8px;display:flex;justify-content:flex-start;align-items:center;">
                              <div  @click="tenantInfo(r)"
                              :title="r.tenantName"
                              style="margin-top:-9px;margin-left:-15px;"
                              v-show="r.tenantId != null && r.tenantId != ''">
                              <el-avatar 
                              icon="el-icon-user-solid"
                              style="width:33px;height:33px;cursor:pointer" ></el-avatar>
                              </div>
                            </el-col>
                            <el-col :span="(r.tenantId != null && r.tenantId != '')?18:24" style="margin-top:-8px;">
                             <span style="float:left;margin-left:-15px;">{{ r.roomName }}</span>
                            </el-col>
                          </el-col>
                          <el-col :span="8">
                            <el-button-group style="margin-top:-15px;margin-right:-17px;display:flex;justify-content:flex-end;align-items:center;">
                              <el-button  size="mini" @click="checkIn(r)" v-show="r.tenantId == null || r.tenantId == ''">{{$t('apartmentRoomList.checkIn')}}</el-button>
                              <el-button  size="mini" @click="manage(r)">{{$t('apartmentRoomList.manage')}}</el-button>
                            </el-button-group>
                          </el-col>
                        </div>
                        <div style="width:100%;height:160px;background-color:#F2F6FC">
                          <div v-for="d in r.deviceList" :key="d.deviceId" class="text item">
                            <el-col :span="12" style="margin-top:5px;">
                              <el-col style="width:100%;display:flex;justify-content:center">
                                 <el-image
                                  :src="require('@/assets/wg.png')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="gatewayDetail(d,r)"
                                  v-show="d.deviceType == '0'"
                                ></el-image>
                                <el-image
                                  :src="require('@/assets/lws.png')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '1'"
                                ></el-image>
                                <el-image
                                  :src="require('@/assets/passLock.png')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '2'"
                                ></el-image>
                                 <el-image
                                  :src="require('@/assets/nblock.jpg')"
                                  style="width: 40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '3'"
                                ></el-image>
                                <el-image
                                  :src="require('@/assets/blelock.jpg')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '4'"
                                ></el-image>
                                 <el-image
                                  :src="require('@/assets/4gLock.png')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '5'"
                                ></el-image>
                                <el-image
                                  :src="require('@/assets/4gLock.png')"
                                  style="width:40px;height:40px;cursor:pointer"
                                  @click="deviceDetail(d,r)"
                                  v-show="d.deviceType == '6'"
                                ></el-image>
                              </el-col>
                              <span style="width:100%;font-size:13px;display:flex;justify-content:center">{{d.deviceType == '4'?d.deviceName+$t('apartmentRoomList.bluetoothLock'):d.deviceName}}</span>
                            </el-col>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                  </div>
                </el-main>
              </el-container>
            </div>
          </el-main>
        </el-container>
      </div>
    </el-card>
  </el-form>
</template> 
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "apartmentRoomList", //公寓房间列表
  props: ["infoData"],
  data() {
    return {
      addTenantVisible:false,
      checkInVisible: false,
      tenantListVisible: false,
      tenantInfoVisible: false,
      formTenantInfo: {
        roomId:"",
        tenantId: "",
        tenantName: "",
        tenantIdentityId:"",
        mobile: "",
        email: "",
        deviceType: ""
      },
      formTenant: {
        tenantId: "",
        tenantName: "",
        sendMessageChecked: "",
        validType: "0",
        password: "",
        card: "",
        cloudUser: "",
        date1: new Date(),
        time1: this.$util.formatHalfTime(new Date()),
        date2: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        time2: "12:00",
        deviceType:'',
        manage:"0"
      },
      tenantList: [],
      pageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      currCheckInRoomData: {},
      currentTenantRow: "",
      formApartment: {
        apartmentType: this.infoData.apartmentType + "",
        editBtnTex: this.$t('apartmentRoomList.edit'), //编辑按钮文字显示
        isDisabled: true, //公寓信息是否编辑状态
        buildings: [],
        selectBuliding: "",
        deviceList: []
      },
      tenantData:null,
      formAddTenant: {//提交表单
        tenantId: "",
        tenantName: "",
        tenantIdentityId:"",
        mobile: "",
        email: "",
        tenantTag:""
      },
      selectForm:{
        tenantName:""
      }
    };
  },
  components: {
    Pagings
  },
  created() {
    // alert(window.JSON.stringify(this.$store.state.apartmentBuilds));
    // this.$store.commit("province", {}); //加载省份
    this.$store.commit("getApartmentDetail", {
      apartmentId: this.infoData.apartmentId
    }); //加载公寓楼栋
    // this.getApartmentRoom();
    // this.$store.commit("getApartmentRoomUsableGateway", {
    //     roomId: this.currRoomData.roomId
    // }); //加载网关详细
    // this.$store.commit("getBindFirstDevice", {
    //   apartmentId: this.infoData.apartmentId,
    //   deviceType: 0
    // }); //加载公寓列表
    this.power();
    // this.getApartmentDetail();
  },
  methods: {
    //查询公寓列表
    onSelectTenant(){
      this.power();
    },
    //确定增加租客
    confirmAddTenant(){
      var formData = new FormData();
      formData.append("tenantName ", this.formAddTenant.tenantName);
      formData.append("tenantIdentityId ", this.formAddTenant.tenantIdentityId);
      formData.append("tenantPhoneCountryId", 86);
      formData.append("tenantPhone", this.formAddTenant.mobile);
      formData.append("tenantEmail", this.formAddTenant.email);
      formData.append("tenantType", 0);
      formData.append("isSendSms", 0);
      formData.append("isLimit", 0);
      this.$server.exam("/customer/tenant/addTenant", formData).then(data => {
        if (data.code == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
          this.addTenantVisible=false;
          this.formAddTenant = {
            tenantId: "",
            tenantName: "",
            mobile: "",
            email: ""
          },
          this.power();
          this.tenantListVisible=true;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //关闭增加租客
    closeAddTenant(){
      this.checkInVisible=true;
      this.addTenantVisible=false;
    },
    //打开增加租客
    addTenant(){
       this.checkInVisible=false;
       this.addTenantVisible=true;
    },
    //保存租客信息
    confirmTenantInfo(){
      var formData = new FormData();
      formData.append("tenantName ", this.formTenantInfo.tenantName);
      formData.append("tenantIdentityId ", this.formTenantInfo.tenantIdentityId);
      formData.append("tenantPhoneCountryId", "86");
      formData.append("tenantPhone", this.formTenantInfo.mobile);
      formData.append("tenantEmail", this.formTenantInfo.email);
      formData.append("tenantType", 0);
      formData.append("isSendSms", 0);
      formData.append("isLimit", 0);
      formData.append("tenantId", this.formTenantInfo.tenantId);
       this.$server.exam("/customer/tenant/editTenant", formData).then(data => {
        if (data.code == 200) {
          this.$message({
            message: data.message,
            type: "success"
          });
          this.tenantInfoVisible=false;
          this.$store.commit("getApartmentDetail", {
            apartmentId: this.infoData.apartmentId
          }); //加载公寓楼栋
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //退租
    checkOut() {
       this.tenantInfoVisible = false;
      this.$confirm(this.$t('apartmentRoomList.isCheckOut')+this.formTenantInfo.tenantName+')?', this.$t('apartmentRoomList.hint'), {
          confirmButtonText:this.$t('apartmentRoomList.confirm'),
          cancelButtonText: this.$t('apartmentRoomList.cancel'),
          type: 'warning'
      }).then(() => {
        var formData = new FormData();
        formData.append("isDelete", 0);
        // switch (this.formTenantInfo.deviceType) {
        //  case 0: //离线锁
        //   formData.append("isDelete", 0);
        //   break;
        //  case 1: //联网锁
        //   formData.append("isDelete", 0);
        //   break;
        // }
        formData.append("roomId", this.formTenantInfo.roomId);
        formData.append("tenantId", this.formTenantInfo.tenantId);
        this.$server.exam("/customer/apartment/checkOut", formData).then(data => {
         if (data.code == 200) {
           this.$message({
            message: data.message,
            type: "success"
           });
           this.$store.commit("getApartmentDetail", {
            apartmentId: this.infoData.apartmentId
           }); //加载公寓楼栋
          } else {
           this.$message({
            message: data.message,
            type: "warning"
           });
         }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
           message: this.$t('apartmentRoomList.cancelCheckOut')
        });          
      });
    },
    //租客信息
    tenantInfo(roomData) {
      // alert(window.JSON.stringify(roomData));
      this.tenantInfoVisible = true;
      this.formTenantInfo.roomId=roomData.roomId;
      this.formTenantInfo.tenantId = roomData.tenantId;
      this.formTenantInfo.tenantName = roomData.tenantName;
      this.formTenantInfo.tenantIdentityId = roomData.tenantIdentityId;
      this.formTenantInfo.mobile = roomData.tenantPhone;
      this.formTenantInfo.email = roomData.tenantEmail=='null'?"":roomData.tenantEmail;
      this.formTenantInfo.deviceType = roomData.deviceList[0].deviceType;
    },
    //确认选择租客
    confirmChooseTenant() {
      if (this.currentTenantRow == "" || this.currentTenantRow == null) {
        this.$message({
          message:this.$t('apartmentRoomList.chooseTenant'),
          type: "warning"
        });
        return false;
      }
      this.checkInVisible = true;
      this.tenantListVisible = false;
      this.formTenant.tenantName = this.currentTenantRow.tenantName;
    },
    //选择租客row
    handleCurrentChange(val) {
      this.currentTenantRow = val;
    },
    //选择租客
    chooseTenant() {
      this.checkInVisible = false;
      this.tenantListVisible = true;
    },
    //打开入住
    checkIn(roomData) {
      this.currCheckInRoomData = roomData;
      if (this.currCheckInRoomData.deviceList == "" ||this.currCheckInRoomData.deviceList == null) {
        this.$message({
          message: this.$t('apartmentRoomList.noBindDevice'),
          type: "error"
        });
        return false;
      }
      this.formTenant.tenantId="";
      this.formTenant.tenantName="";
      this.formTenant.deviceType=roomData.deviceList[0].deviceType;
      this.checkInVisible = true;
    },
    //确定入住
    confirmCheckIn() {
      var tenantData = this.currentTenantRow;
      var checkInRoomData = this.currCheckInRoomData;
      var formData = new FormData();
      var date1 = this.$util.formartDate(this.formTenant.date1);
      var time1 = this.formTenant.time1+":00";
      var date2 = this.$util.formartDate(this.formTenant.date2);
      var time2 = this.formTenant.time2+":00";
      if (this.formTenant.time1 == "" || this.formTenant.time1 == null) {
        this.$message({
          message: this.$t('apartmentRoomList.chooseTime'),
          type: "error"
        });
        return false;
      }
      if (this.formTenant.time2 == "" || this.formTenant.time2 == null) {
        this.$message({
          message:this.$t('apartmentRoomList.chooseTime'),
          type: "error"
        });
        return false;
      }

      formData.append("roomId", checkInRoomData.roomId);
      formData.append("beginTime", date1 + " " + time1);
      formData.append("endTime", date2 + " " + time2);
      formData.append("isLimit", 1);
      formData.append("tenantId", tenantData.tenantId);
      formData.append("isManager", parseInt(this.formTenant.manage));
      var authList = [];
      var authObj = {};
      authObj.authorizationName = this.currentTenantRow.tenantName;
      authObj.isLocked = 0;
      authObj.isOpen = 0;
      authObj.isOpenPublicDoor = 0;
      //搜索出门锁
      // var lockData = checkInRoomData.deviceList.filter(function (item) {
      //     return item.offLineLockType!=0
      // });
      // alert(window.JSON.stringify(checkInRoomData.deviceList));
      // if(checkInRoomData.deviceList==""|| checkInRoomData.deviceList.length==0){
      //   this.$message({
      //     message: this.$t('apartmentRoomList.noBindDevice'),
      //     type: "error"
      //   }); 
      //   return false;
      // }
      var lockData=checkInRoomData.deviceList;
      var deviceType=this.getDeviceTypeByList(checkInRoomData.deviceList);//获取设备类型
      switch (deviceType) {
        case 2://离线锁
          authObj.validUser = 3;
          authObj.validType = 0;//密码
          break;
        case 5://NB联网锁   
        case 3://NB联网锁  
        case 1://联网锁
          authObj.validUser = 2;
          authObj.validType = 0;//密码
          break;
        case 4://蓝牙锁
          authObj.validUser = 3;
          authObj.validType = 0;//密码
          break;  
      }
      // //判断授权内容
      // switch (this.formTenant.validType) {
      //   case "0":
      //     authObj.validType = 0;
      //     authObj.validData = this.formTenant.password;
      //     break;
      //   case "1":
      //     authObj.validType = 1;
      //     authObj.validData = this.formTenant.card;
      //     break;
      //    case "2":
      //      authObj.validType = 4;
      //      break;
      // }
      //判断是否发送信息
      switch (this.formTenant.sendMessageChecked) {
        case "": //不发送信息
          authObj.isSendSms = 0;
          break;
        case "0": //发送短信
          authObj.isSendSms = 1;
          authObj.sendChannel = 0;
          authObj.countryId=86;
          if(this.currentTenantRow.tenantPhone==null||this.currentTenantRow.tenantPhone==""){
              this.$message({
                message:this.$t('apartmentRoomList.tenantPhone-input'),
                type: "success"
              });
             return false;
          }
          authObj.mobile = this.currentTenantRow.tenantPhone;
          break;
        case "1": //发送邮箱
          authObj.isSendSms = 1;
          authObj.sendChannel = 1;
          authObj.countryId=86;
          if(this.currentTenantRow.tenantEmail==null||this.currentTenantRow.tenantEmail==""){
             this.$message({
                message:this.$t('apartmentRoomList.emailRegisterHint'),
                type: "success"
              });
             return false;
          }
          authObj.email = this.currentTenantRow.tenantEmail;
          break;
      }
      authList.push(authObj);
      formData.append("authorizationList", window.JSON.stringify(authList));
      this.$server.exam("/customer/apartment/checkIn", formData).then(data => {
        if (data.code == 200) {
          this.checkInVisible = false;
          switch (deviceType) {
            case 2://离线锁
              this.$message({
                message: data.message,
                type: "success"
              });
              this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId
              }); //加载公寓楼栋
              break;
            case 5://NB联网锁   
            case 3://NB联网锁  
            case 1://联网锁
              if(data.data[0]==null ||data.data[0]==""){
                this.$message({
                 message: this.$t('update.lockError'),
                 type: "warning"
                });
                this.$store.commit("getApartmentDetail", {
                  apartmentId: this.infoData.apartmentId
                }); //加载公寓楼栋
                return false;
              }
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              var obj = {};
              obj.rId = data.data[0].recordId;
              obj.loading = loading;
              obj.opType = "checkIn";
              obj.othis = this;
              obj.apartmentId = this.infoData.apartmentId;
              this.$store.dispatch("checkResult", obj); //等待回调
              break;
            case 4://蓝牙锁
              this.$message({
                message: data.message,
                type: "success"
              });
              this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId
              }); //加载公寓楼栋
              break;  
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    //设备详细
    deviceDetail(deviceData,roomData) {
      deviceData.roomId=roomData.roomId;
      this.$mainInfo.addDevcieDetail(deviceData);
    },
    //设备详细
    gatewayDetail(deviceData,roomData) {
      deviceData.roomId=roomData.roomId;
      this.$mainInfo.addGatewayDetail(deviceData);
    },
    //管理房间
    manage(roomData) {
      this.$mainInfo.addManageRoom(roomData);
    },
    //公共区域
    commomArea(floorData) {
      this.$mainInfo.addCommomArea(floorData);
    },

    getCityValue(val) {
      this.$store.commit("area", { cityCode: val }); //加载区（县）
      this.formApartment.area = "";
    },
    getProvinceValue(val) {
      this.$store.commit("city", { provinceCode: val }); //加载城市
      this.formApartment.city = "";
      this.formApartment.area = "";
    },
    roomList() {
      var formData = new FormData();
      formData.append("apartmentId", this.infoData.apartmentId);
      this.$server
        .exam("/customer/apartment/listApartmentRoom", formData)
        .then(data => {
          if (data.code == 200) {
            this.formApartment.roomData = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
   getDeviceTypeByList(deviceList){
      var rtn="";
      for(var str in deviceList){
         if(deviceList[str].deviceType!=0){
            this.formTenantInfo.deviceId=deviceList[str].deviceId;
            rtn=deviceList[str].deviceType;
         }
      }
      return rtn;
    },
    power() {
      var formData = new FormData();
      if(this.selectForm.tenantName!=""&&this.selectForm.tenantName!=null){
        formData.append("tenantName",this.selectForm.tenantName);
      }
      // formData.append("apartmentId",this.infoData.apartmentId);
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server.exam("/customer/tenant/listTenant", formData).then(data => {
        if (data.code == 200) {
          this.tenantList = data.data.records;
          this.total = data.data.total;
          // this.oAssEquipmentDto.offset = 1;
          // this.oAssEquipmentDto.pageNumber = data.data.pages;
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
    handleSizeChangeT(val) {
      this.pageData.pageNumber = val;
      this.power();
    },
    handleCurrentChangeT(val) {
      this.pageData.offset = val;
      this.power();
    }
    // getApartmentDetail() {
    //   var formData = new FormData();
    //   formData.append("apartmentId", this.infoData.apartmentId);
    //   this.$server
    //     .exam("/customer/apartment/getApartmentDetail", formData)
    //     .then(d => {
    //       if (d.code == 200) {
    //         var apmData = d.data.buildingDetailList;
    //         this.formApartment.buildings = apmData;
    //         // for (var str in apmData) {
    //         //   var bldData = apmData[str];
    //         //   var floorData = bldData.floorList;
    //         //   this.formApartment.floors = bldData.floorList;
    //         //   //alert(window.JSON.stringify(bldData.floorList[0].roomList[0].deviceList));
    //         // }
    //       } else {
    //         this.$message({
    //           message: d.message,
    //           type: "warning"
    //         });
    //       }
    //     });
    // }
  }
};
</script>  

<style scoped>
 /*清除浮动代码*/
   .clearfloat:after{display:block;clear:both;content:"";visibility:hidden;height:0}
   .clearfloat{zoom:1}
</style>


// WEBPACK FOOTER //
// src/components/device/apartmentRoomList.vue